module.exports = __webpack_public_path__ + "static/media/exportData.d27b5206.svg";